module.exports = __webpack_public_path__ + "img/grey_025.5b4aa1ef.png";